export function getRequiredDocuments() {
    return {
        "success": true,
        "data": [
            {
                "_id": "6810842055f7190073871f7f",
                "allowedFileTypes": [
                    "pdf",
                    "doc",
                    "jpg"
                ],
                "isActive": true,
                "name": "Resume",
                "maxFileSize": 1,
                "numberOfFiles": 1,
                "company": "Sparkle Star International - Inhouse",
                "storeId": "61441920a6566a001623b90d",
                "createdBy": null,
                "createdAt": "2025-04-29T07:47:44.133Z",
                "updatedAt": "2025-05-02T09:58:05.917Z",
                "__v": 0,
                "requiresExpiration": true,
                "updatedBy": null
            },
            {
                "_id": "6810843055f719007387200c",
                "allowedFileTypes": [
                    "jpeg",
                    "png"
                ],
                "isActive": true,
                "name": "Biodata",
                "maxFileSize": 1,
                "numberOfFiles": 1,
                "company": "Sparkle Star International - Inhouse",
                "storeId": "61441920a6566a001623b90d",
                "createdBy": null,
                "createdAt": "2025-04-29T07:48:00.622Z",
                "updatedAt": "2025-05-02T09:58:11.063Z",
                "__v": 0,
                "requiresExpiration": true,
                "updatedBy": null
            },
        ]
    }
}


export function uploadedDocuments() {
    return [
        {
            "status": "pending_approval",
            "expirationDate": "2026-04-13T00:00:00.000Z",
            "rejectionReason": null,
            "reviewedBy": null,
            "reviewedAt": null,
            "_id": "69dc6a4838877181290f2557",
            "employeeId": "61442a17a6566a001623bf20",
            "requiredDocumentId": "6810842055f7190073871f7f",
            "files": [
                {
                    "_id": "test_id",
                    "name": "2x2 picture.jpg",
                    "size": 180763,
                    "type": "image/jpeg",
                    "url": "https://yavuzceliker.github.io/sample-images/image-1.jpg",
                    "key": "documents/61442a17a6566a001623bf20/6810842055f7190073871f7f/1776052807649.jpg"
                },
            ],
            "createdAt": "2026-04-13T04:00:08.374Z",
            "updatedAt": "2026-04-13T04:00:08.374Z",
            "__v": 0
        }
    ]
}


export function getDocumentsStatusOfEmployees() {
    return {
        "success": true,
        "data": {
            "employeeDocumentStatus": {
                "66a985cd1eba0f002e7c4cde": {
                    "status": "missing",
                    "counts": {
                        "pending": 0,
                        "approved": 0,
                        "rejected": 0,
                        "expired": 0,
                        "missing": 5,
                        "total": 5
                    },
                    "documents": []
                }
            },
            "requiredDocuments": [
                {
                    "_id": "6810842055f7190073871f7f",
                    "allowedFileTypes": [
                        "pdf",
                        "doc",
                        "jpg"
                    ],
                    "isActive": true,
                    "name": "test",
                    "maxFileSize": 5,
                    "numberOfFiles": 2,
                    "company": "Sparkle Star International - Inhouse",
                    "storeId": "61441920a6566a001623b90d",
                    "createdBy": null,
                    "createdAt": "2025-04-29T07:47:44.133Z",
                    "updatedAt": "2025-05-02T09:58:05.917Z",
                    "__v": 0,
                    "requiresExpiration": true,
                    "updatedBy": null
                },
                {
                    "_id": "6810843055f719007387200c",
                    "allowedFileTypes": [
                        "jpeg",
                        "png"
                    ],
                    "isActive": true,
                    "name": "test2",
                    "maxFileSize": 5,
                    "numberOfFiles": 1,
                    "company": "Sparkle Star International - Inhouse",
                    "storeId": "61441920a6566a001623b90d",
                    "createdBy": null,
                    "createdAt": "2025-04-29T07:48:00.622Z",
                    "updatedAt": "2025-05-02T09:58:11.063Z",
                    "__v": 0,
                    "requiresExpiration": true,
                    "updatedBy": null
                },
                {
                    "_id": "681494cd48e7bb723905573d",
                    "allowedFileTypes": [
                        "jpeg",
                        "png"
                    ],
                    "requiresExpiration": false,
                    "isActive": true,
                    "name": "test3",
                    "maxFileSize": 5,
                    "numberOfFiles": 1,
                    "company": "Sparkle Star International - Inhouse",
                    "storeId": "61441920a6566a001623b90d",
                    "createdBy": null,
                    "createdAt": "2025-05-02T09:47:57.095Z",
                    "updatedAt": "2025-05-02T09:47:57.095Z",
                    "__v": 0
                },
                {
                    "_id": "6889da3d80a6e30087bc407f",
                    "allowedFileTypes": [
                        "doc"
                    ],
                    "requiresExpiration": false,
                    "isActive": true,
                    "name": "test4",
                    "maxFileSize": 5,
                    "numberOfFiles": 1,
                    "company": "Sparkle Star International - Inhouse",
                    "storeId": "61441920a6566a001623b90d",
                    "createdBy": null,
                    "createdAt": "2025-07-30T08:39:25.234Z",
                    "updatedAt": "2025-07-30T08:39:25.234Z",
                    "__v": 0
                },
                {
                    "_id": "6889da763711110087324d6c",
                    "allowedFileTypes": [
                        "doc"
                    ],
                    "requiresExpiration": false,
                    "isActive": true,
                    "name": "test5",
                    "maxFileSize": 5,
                    "numberOfFiles": 1,
                    "company": "Sparkle Star International - Inhouse",
                    "storeId": "61441920a6566a001623b90d",
                    "createdBy": null,
                    "createdAt": "2025-07-30T08:40:22.728Z",
                    "updatedAt": "2025-07-30T08:40:22.728Z",
                    "__v": 0
                }
            ]
        }
    }
}

//http://localhost:8000/api/required-documents/6810842055f7190073871f7f//
export function editDocument() {
    return {
        "success": true,
        "data": {
            "_id": "6810842055f7190073871f7f",
            "allowedFileTypes": [
                "pdf",
                "doc",
                "jpg"
            ],
            "isActive": true,
            "name": "test",
            "maxFileSize": 5,
            "numberOfFiles": 2,
            "company": "Sparkle Star International - Inhouse",
            "storeId": "61441920a6566a001623b90d",
            "createdBy": null,
            "createdAt": "2025-04-29T07:47:44.133Z",
            "updatedAt": "2025-05-02T09:58:05.917Z",
            "__v": 0,
            "requiresExpiration": true,
            "updatedBy": null
        }
    }
}


export function updateDocument(){
    
}